import MaintenanceHistory from '@/models/MaintenanceHistory/MaintenanceHistory';

export default class MaintenanceHistoryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderExecutionnId  = '';
		this.workOrderExecutionnShift = '';
		this.troubleReportMultiple = '';
		this.analisaDanPenyebabMultiple = '';
		this.tindakanMultiple = '';
		this.picTypeId  = '';
		this.picTypeName = '';
		this.picName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderExecutionnId : '0',
			workOrderExecutionnShift : '0',
			troubleReportMultiple : '0',
			analisaDanPenyebabMultiple : '0',
			tindakanMultiple : '0',
			picTypeId : '0',
			picTypeName : '0',
			picName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}